import React from 'react';

export const JwtContext = React.createContext();
